// Header
$('#identity .header-reviews').on('click', function() {
	//ga('send', 'event', 'Header', 'Desktop - Header - Reviews', 'Click');
window.RF_Events('Header', 'Desktop - Header - Reviews', 'Click');
});
$('#identity #logo a').on('click', function() {
  	if ($(window).width() < 761) {
       // //ga('send', 'event', 'Header', 'Mobile - Logo Rockford Collection', 'Click');
window.RF_Events('Header', 'Mobile - Logo Rockford Collection', 'Click');
    } else {
		//ga('send', 'event', 'Header', 'Desktop - Header - Logo', 'Click');
window.RF_Events('Header', 'Desktop - Header - Logo', 'Click');
    }
});

$('#identity .cs-action').on('click', function() {
	//ga('send', 'event', 'Header', 'Desktop - Header - Search', 'Click');
window.RF_Events('Header', 'Desktop - Header - Search', 'Click');
});
$('#identity .cs-input.active').on('click', function() {
	//ga('send', 'event', 'Header', 'Desktop - Header - Search Initiated', 'Click');
window.RF_Events('Header', 'Desktop - Header - Search Initiated', 'Click');
});
$('#identity span.item_count.new-cart-icon').on('click', function() {
	//ga('send', 'event', 'Header', 'Desktop - Header - Shopping Cart', 'Click');
window.RF_Events('Header', 'Desktop - Header - Shopping Cart', 'Click');
});
$('#identity #currencies').on('click', function() {
	//ga('send', 'event', 'Header', 'Desktop - Header - Currency', 'Click');
window.RF_Events('Header', 'Desktop - Header - Currency', 'Click');
});
$('#identity .top-phone a').on('click', function() {
	//ga('send', 'event', 'Header', 'Desktop - Header - Call', 'Click');
window.RF_Events('Header', 'Desktop - Header - Call', 'Click');
});

$('#navigation #nav a').on('click', function() {
  	var this_text = $(this).text();
	//ga('send', 'event', 'Header', 'Desktop - Menu - '+this_text, 'Click');
});
$("#mobile-menu").on("click", ".shifter-handle", function(){
    if ($(this).hasClass('active')) {
       // //ga('send', 'event', 'Header', 'Mobile - Topbar - Hamburger Close', 'Click');
window.RF_Events('Header', 'Mobile - Topbar - Hamburger Close', 'Click');
    } else {
       // //ga('send', 'event', 'Header', 'Mobile - Topbar - Hamburger Open', 'Click');
window.RF_Events('Header', 'Mobile - Topbar - Hamburger Open', 'Click');
    }
}); 
$("#mobile-menu").on("click", ".mobile-search", function(){
   // //ga('send', 'event', 'Header', 'Mobile - Topbar - Search Click', 'Click');
window.RF_Events('Header', 'Mobile - Topbar - Search Click', 'Click');
});
$('#mobile-logo a').on('click', function() {
	//ga('send', 'event', 'Header', 'Mobile - Topbar - RF Logo', 'Click');
window.RF_Events('Header', 'Mobile - Topbar - RF Logo', 'Click');
});
$('.mobile-1.mobile-cart-phone > li:nth-child(2) > a').on('click', function() {
	//ga('send', 'event', 'Header', 'Mobile - Topbar - Call', 'Click');
window.RF_Events('Header', 'Mobile - Topbar - Call', 'Click');
});
$('.mobile-1.mobile-cart-phone li#mobile-cart a').on('click', function() {
	//ga('send', 'event', 'Header', 'Mobile - Topbar - Shopping Cart', 'Click');
window.RF_Events('Header', 'Mobile - Topbar - Shopping Cart', 'Click');
});
$('.mobile-navigation li a').on('click', function() {
    var this_text = $(this).text();
	//ga('send', 'event', 'Header', 'Mobile - Menu - '+this_text, 'Click');
});
$('.mobile-navigation li .mn-item-with-subitems').on('click', function() {
    var this_text = $(this).text();
	//ga('send', 'event', 'Header', 'Mobile - Menu - '+this_text, 'Click');
});
// $('.mobile-navigation li.sub-item-title').on('click', function() {
//     var this_text = $(this).text();
// 	//ga('send', 'event', 'Header', 'Mobile - Menu - Return From - '+this_text, 'Click');
// });
// Header


$('body').find('.pdp-ar.pc-ar-ready').click(function(){
	//ga('send', 'event', 'Product Page', 'Product Page - Mobile - AR OPEN', 'Click');
window.RF_Events('Product Page', 'Product Page - Mobile - AR OPEN', 'Click');
});

// Footer
$('.footer-book-appointment-btn').on('click', function() {
	//ga('send', 'event', 'Front Page', 'Footer - Block Book an appointment bottom - Button', 'Click');
window.RF_Events('Front Page', 'Footer - Block Book an appointment bottom - Button', 'Click');
});
$('.footer-call-number-btn').on('click', function() {
	//ga('send', 'event', 'Front Page', 'Footer - Block Book an appointment bottom - Call', 'Click');
window.RF_Events('Front Page', 'Footer - Block Book an appointment bottom - Call', 'Click');
});

$('a.footer-social.fs-fb').on('click', function() {
	//ga('send', 'event', 'Footer', 'Footer - Social - FB', 'Click');
window.RF_Events('Footer', 'Footer - Social - FB', 'Click');
});
$('a.footer-social.fs-tw').on('click', function() {
	//ga('send', 'event', 'Footer', 'Footer - Social - Twitter', 'Click');
window.RF_Events('Footer', 'Footer - Social - Twitter', 'Click');
});
$('a.footer-social.fs-pn').on('click', function() {
	//ga('send', 'event', 'Footer', 'Footer - Social - Pinterest', 'Click');
window.RF_Events('Footer', 'Footer - Social - Pinterest', 'Click');
});
$('a.footer-social.fs-in').on('click', function() {
	//ga('send', 'event', 'Footer', 'Footer - Social - Instagram', 'Click');
window.RF_Events('Footer', 'Footer - Social - Instagram', 'Click');
});

$('footer .livechat_button').on('click', function() {
	//ga('send', 'event', 'Footer', 'Footer - Contact Us - Chat Now', 'Click');
window.RF_Events('Footer', 'Footer - Contact Us - Chat Now', 'Click');
});
$('footer .footer-left-call-us').on('click', function() {
	//ga('send', 'event', 'Footer', 'Footer - Contact Us - Call', 'Click');
window.RF_Events('Footer', 'Footer - Contact Us - Call', 'Click');
});
$('footer .footer-left-email-us').on('click', function() {
	//ga('send', 'event', 'Footer', 'Footer - Contact Us - Email', 'Click');
window.RF_Events('Footer', 'Footer - Contact Us - Email', 'Click');
});
$('footer .footer-calendy').on('click', function() {
	var device = '';
	if ($(window).width() < 960) {
		device = 'Mobile';
	} else {
		device = 'Desktop';
	}
	var this_name = '';
	if ($(this).hasClass('footer-calendy-virtual-appointment')) {
		this_name = 'Book a Virtual Appointment';
	} else if ($(this).hasClass('footer-calendy-30min')) {
		this_name = 'Book an Appointment in NYC';
	} else if ($(this).hasClass('footer-calendy-miami')) {
		this_name = 'Book an Appointment in Miami';
	}
	//ga('send', 'event', 'Footer', 'Footer - '+device+' - Contact Us - Calendy -'+this_name, 'Click');
});
$('footer .footer-left-location').on('click', function() {
	//ga('send', 'event', 'Footer', 'Footer - Contact Us - Location', 'Click');
window.RF_Events('Footer', 'Footer - Contact Us - Location', 'Click');
});

$('footer .footer_link').on('click', function() {
    var this_text = $(this).text();
	//ga('send', 'event', 'Footer', 'Footer - Information - '+this_text, 'Click');
});

// Footer



// Home Page
// $('.rdesign a').on('click', function() {
//     var this_text = $(this).find('h4').text();
// 	//ga('send', 'event', 'Front Page', 'Front Page - Block 6rings - '+this_text, 'Click');
// });
$('body').find('.irc-dot-item').mouseenter(function(){
    var this_text = $(this).parent().parent().find('h4').text();
	//ga('send', 'event', 'Front Page', 'Front Page - Block 6rings - '+this_text+' - Color Selector', 'Click');
});
$('.irc-btn').on('click', function() {
	//ga('send', 'event', 'Front Page', 'Front Page - Block 6rings - Button View All', 'Click');
window.RF_Events('Front Page', 'Front Page - Block 6rings - Button View All', 'Click');
});
$('.index-book-btn').on('click', function() {
	//ga('send', 'event', 'Front Page', 'Front Page - Block Book an appointment top - Button', 'Click');
window.RF_Events('Front Page', 'Front Page - Block Book an appointment top - Button', 'Click');
});
$('.index-view-ring').on('click', function() {
	//ga('send', 'event', 'Front Page', 'Front Page - Block Made to Order - Button View Ring', 'Click');
window.RF_Events('Front Page', 'Front Page - Block Made to Order - Button View Ring', 'Click');
});
$('.index-discover-collection').on('click', function() {
	//ga('send', 'event', 'Front Page', 'Front Page - Block The American Legends - Button Discover Collection', 'Click');
window.RF_Events('Front Page', 'Front Page - Block The American Legends - Button Discover Collection', 'Click');
});
$('.index-read-policy').on('click', function() {
	//ga('send', 'event', 'Front Page', 'Front Page - Block Lifetime Warranty - Link Read Policy', 'Click');
window.RF_Events('Front Page', 'Front Page - Block Lifetime Warranty - Link Read Policy', 'Click');
});
$('.index-bottom-veiw-collection').on('click', function() {
	//ga('send', 'event', 'Front Page', 'Front Page - Block Lifetime Warranty - Button View Collection', 'Click');
window.RF_Events('Front Page', 'Front Page - Block Lifetime Warranty - Button View Collection', 'Click');
});
$('.flexslider.rf-flexslider.white-bg-top .col1 button a').on('click', function() {
	//ga('send', 'event', 'Front Page', 'Front Page - Block Main Banner - View Styles Button', 'Click');
window.RF_Events('Front Page', 'Front Page - Block Main Banner - View Styles Button', 'Click');
});
// Home Page



// Collection Page
$(".filter-select").on("click", ".filter-value", function(){
    var this_val = $(this).text();
    var this_text = $(this).parent().parent().find('.filter-title').text();
	//ga('send', 'event', 'Collection Page', 'Collection Page - Filter by - '+this_text+' - '+this_val, 'Click');
});
$('#sort-by').on('change', function() {
  	var this_val = $(this).val();
	//ga('send', 'event', 'Collection Page', 'Collection Page - Sort By - '+this_val, 'Click');
});
$('#product-loop .prod-container a').on("click", ".filter-value", function(){
    var this_text = $(this).parent().parent().data('alpha');
	//ga('send', 'event', 'Collection Page', 'Collection Page - '+this_text, 'Click');
});
$(document).on('mouseenter', '.col-swatch ul li.color span', function () {  
    var this_val = $(this).parent().data('option-title');
    var this_text = $(this).parent().parent().parent().parent().data('alpha');
	//ga('send', 'event', 'Collection Page', 'Collection Page - '+this_text+' - Color Selector - '+this_val, 'Click');
}); 
$('.collection #pagination a').on('click', function() {
    var this_text = $(this).text();
  	var last_item = $(this).parent().find('a:nth-last-child(2)').text();
	//ga('send', 'event', 'Front Page', 'Collection Page - Showing Page - '+this_text+'/'+last_item, 'Click');
});
// Collection Page



// Product Page
$(document).on('click', '.__affirm-logo', function() {
   // //ga('send', 'event', 'Product', 'Affirm', 'Click');
window.RF_Events('Product', 'Affirm', 'Click');
    $('.affirm-modal-trigger').click();
});
$('#main-image a.img_link').on('click', function() {
	//ga('send', 'event', 'Product Page', 'Product Page - Desktop -  Gallery - Thumbnails', 'Click');
window.RF_Events('Product Page', 'Product Page - Desktop -  Gallery - Thumbnails', 'Click');
});
$('#main-image a.video_link ').on('click', function() {
	//ga('send', 'event', 'Product Page', 'Product Page - Desktop -  Gallery - Animation', 'Click');
window.RF_Events('Product Page', 'Product Page - Desktop -  Gallery - Animation', 'Click');
});
$("#main-image").on("click", ".desktop-wishlist-icon", function(){
	//ga('send', 'event', 'Product Page', 'Product Page - Desktop -  Gallery - Wishlist', 'Click');
window.RF_Events('Product Page', 'Product Page - Desktop -  Gallery - Wishlist', 'Click');
});
$("#product-right").on("click", ".affirm-modal-trigger", function(){
	//ga('send', 'event', 'Product Page', 'Product Page - Affirm - Below price', 'Click');
window.RF_Events('Product Page', 'Product Page - Affirm - Below price', 'Click');
});
$('#product-right .size-guide a').on('click', function() {
	//ga('send', 'event', 'Product Page', 'Product Page - Size Guide ', 'Click');
window.RF_Events('Product Page', 'Product Page - Size Guide ', 'Click');
});
$("#product-right").on("click", "#buy-now-pay-later", function(){
	//ga('send', 'event', 'Product Page', 'Product Page - Affirm - Button', 'Click');
window.RF_Events('Product Page', 'Product Page - Affirm - Button', 'Click');
});
$('#product-right .ask-question a').on('click', function() {
	//ga('send', 'event', 'Product Page', 'Product Page - Ask a question', 'Click');
window.RF_Events('Product Page', 'Product Page - Ask a question', 'Click');
});
$("body.product").on("click", ".contactFormSubmit", function(){
	//ga('send', 'event', 'Product Page', 'Product Page - Ask a question - Button Send', 'Click');
window.RF_Events('Product Page', 'Product Page - Ask a question - Button Send', 'Click');
});
$('#product-right .call-about-product a').on('click', function() {
	//ga('send', 'event', 'Product Page', 'Product Page - Call', 'Click');
window.RF_Events('Product Page', 'Product Page - Call', 'Click');
});
$('#product-right .drop-link').on('click', function() {
	//ga('send', 'event', 'Product Page', 'Product Page - Drop a hint Icon', 'Click');
window.RF_Events('Product Page', 'Product Page - Drop a hint Icon', 'Click');
});
$('#product-right .a2a_button_sms').on('click', function() {
	//ga('send', 'event', 'Product Page', 'Product Page - Drop a hint - Text', 'Click');
window.RF_Events('Product Page', 'Product Page - Drop a hint - Text', 'Click');
});
$('#product-right .a2a_button_whatsapp').on('click', function() {
	//ga('send', 'event', 'Product Page', 'Product Page - Drop a hint - Whatsapp', 'Click');
window.RF_Events('Product Page', 'Product Page - Drop a hint - Whatsapp', 'Click');
});
$('#product-right .a2a_button_facebook_messenger').on('click', function() {
	//ga('send', 'event', 'Product Page', 'Product Page - Drop a hint - Facebook Messenger', 'Click');
window.RF_Events('Product Page', 'Product Page - Drop a hint - Facebook Messenger', 'Click');
});
$('#product-right .a2a_button_email').on('click', function() {
	//ga('send', 'event', 'Product Page', 'Product Page - Drop a hint - Email', 'Click');
window.RF_Events('Product Page', 'Product Page - Drop a hint - Email', 'Click');
});
$(".ring-variations-grid").on("click", "a", function(){
    var this_title = $(this).parent().parent().data('rp_name');
	//ga('send', 'event', 'Product Page', 'Product Page - Ring Variations - '+this_title, 'Click');
});
$('#product-right .rv-loadmore').on('click', function() {
	//ga('send', 'event', 'Product Page', 'Product Page - Ring Variations - Button Load More', 'Click');
window.RF_Events('Product Page', 'Product Page - Ring Variations - Button Load More', 'Click');
});
$('.apb-3-blocks').find('.apb-3-link').on('click', function() {
  	var this_title_block = $(this).parent().find('.apb-3-title').text();
  	var this_title_arr = this_title_block.split(' ');
  	var this_title = this_title_block.replace(this_title_arr[0]+' ', '');
	//ga('send', 'event', 'Product Page', 'Product Page - 3 blocks - '+this_title+' Learn More', 'Click');
});
$('.apb-content-blocks a.apb-content-link').on('click', function() {
	//ga('send', 'event', 'Product Page', 'Product Page - American legends collection - Button Read the stories', 'Click');
window.RF_Events('Product Page', 'Product Page - American legends collection - Button Read the stories', 'Click');
});
$('.related-products-block a.cy').on('click', function() {
    var this_title = $(this).parent().parent().data('pr_title');
	//ga('send', 'event', 'Product Page', 'Product Page - More in this collection - Clicks', 'Click');
window.RF_Events('Product Page', 'Product Page - More in this collection - Clicks', 'Click');
   // //ga('send', 'event', 'Product Page', 'Product Page - More in this collection - '+this_title, 'Click');
});
$('.mob-wishlist-icon').on('click', function() {
	//ga('send', 'event', 'Product Page', 'Product Page - Mobile - Gallery - Wishlist', 'Click');
window.RF_Events('Product Page', 'Product Page - Mobile - Gallery - Wishlist', 'Click');
});
$('#mob-product-images').on("click", ".owl-next", function(){
  	//ga('send', 'event', 'Product Page', 'Product Page - Mobile - Gallery - Next Picture', 'Click');
window.RF_Events('Product Page', 'Product Page - Mobile - Gallery - Next Picture', 'Click');
});
$('#mob-product-images').on("click", ".owl-prev", function(){
  	//ga('send', 'event', 'Product Page', 'Product Page - Mobile - Gallery - Prev Picture', 'Click');
window.RF_Events('Product Page', 'Product Page - Mobile - Gallery - Prev Picture', 'Click');
});
$('.mob-zoom-in').on('click', function() {
	//ga('send', 'event', 'Product Page', 'Product Page - Mobile - Gallery - Zoom in', 'Click');
window.RF_Events('Product Page', 'Product Page - Mobile - Gallery - Zoom in', 'Click');
});
$('#custom-fields-accordion .accordion-section a').on('click', function() {
    var this_href = $(this).attr('href');
	//ga('send', 'event', 'Product Page', 'Product Page - Tab '+this_href, 'Click');
});

$(".product-reviews").on("click", ".slick-arrow", function(){
  	if ($(this).hasClass('slick-next')) {
       // //ga('send', 'event', 'Product Page', 'Product Page - Tab #reviews - Next', 'Click');
window.RF_Events('Product Page', 'Product Page - Tab #reviews - Next', 'Click');  
    } else {
       // //ga('send', 'event', 'Product Page', 'Product Page - Tab #reviews - Prev', 'Click');
window.RF_Events('Product Page', 'Product Page - Tab #reviews - Prev', 'Click');  
    }
});
$('#order_a_sample .shopify-buy-frame').on('click', function() {
	//ga('send', 'event', 'Product Page', 'Product Page - Tab #order_a_sample - Button', 'Click');
window.RF_Events('Product Page', 'Product Page - Tab #order_a_sample - Button', 'Click');
});
$('#customize_the_ring a').on('click', function() {
	//ga('send', 'event', 'Product Page', 'Product Page - Tab #customize_the_ring - Learn More', 'Click');
window.RF_Events('Product Page', 'Product Page - Tab #customize_the_ring - Learn More', 'Click');
});
$('#free_shipping_and_returns a').on('click', function() {
  	var this_title = $(this).attr('title');
	//ga('send', 'event', 'Product Page', 'Product Page - Tab #free_shipping_and_returns - '+this_title+' - Learn More', 'Click');
});
$('.watch-video a').on('click', function() {
	//ga('send', 'event', 'Product Page', 'Product Page - Watch Video', 'Click');
window.RF_Events('Product Page', 'Product Page - Watch Video', 'Click');
});

$('#chat-widget-containero').on('click', function() {
	//ga('send', 'event', 'Product Page', 'Product Page - Chat button', 'Click');
window.RF_Events('Product Page', 'Product Page - Chat button', 'Click');
});

$('ul#popups li.call-about-product a').on('click', function() {
  	//ga('send', 'event', 'Product Page', 'Product o Call', 'Click');
window.RF_Events('Product Page', 'Product o Call', 'Click');
});
$('body').find('.desk-size-initials-container').find('.msg-initials-engraving').find('a').on('click', function() {
  	//ga('send', 'event', 'Product Page', 'Product Page - Desktop - Initials & Engraving click', 'Click');
window.RF_Events('Product Page', 'Product Page - Desktop - Initials & Engraving click', 'Click');
});
$('body').find('.desk-size-initials-container').find('.band-size-guide').find('a').on('click', function() {
  	//ga('send', 'event', 'Product Page', 'Product Page - Desktop - Size Guide', 'Click');
window.RF_Events('Product Page', 'Product Page - Desktop - Size Guide', 'Click');
});
$('body').find('.mob-size-guide.msg-custom-note').find('.msg-initials-engraving').find('a').on('click', function() {
  	//ga('send', 'event', 'Product Page', 'Product Page - Mobile - Initials & Engraving click', 'Click');
window.RF_Events('Product Page', 'Product Page - Mobile - Initials & Engraving click', 'Click');
});
$('body').find('.mob-size-guide.msg-custom-note').find('.band-size-guide').find('a').on('click', function() {
  	//ga('send', 'event', 'Product Page', 'Product Page - Mobile - Size Guide', 'Click');
window.RF_Events('Product Page', 'Product Page - Mobile - Size Guide', 'Click');
});
// Product Page


// Cart Page

$("body.cart").on("click", ".affirm-modal-trigger", function(){
  	//ga('send', 'event', 'Shopping Cart Page', 'Shopping Cart Page - Affirm', 'Click');
window.RF_Events('Shopping Cart Page', 'Shopping Cart Page - Affirm', 'Click');
});
$("body.cart").on("click", ".slick-arrow", function(){
  	//ga('send', 'event', 'Shopping Cart Page', 'Shopping Cart Page - Reviews', 'Click');
window.RF_Events('Shopping Cart Page', 'Shopping Cart Page - Reviews', 'Click');
});
$("body.cart").on("click", "a.partiallyButton", function(e){
	e.preventDefault();
	var this_href = $(this).attr('href');
  	//ga('send', 'event', 'Shopping Cart Page', 'Shopping Cart Page - Partial.ly Btm', 'Click');
window.RF_Events('Shopping Cart Page', 'Shopping Cart Page - Partial.ly Btm', 'Click');
setTimeout(function(){
	window.location.href = this_href;
}, 700);
}); 
$('body.cart').find('.faq-question').click(function(){
    if ($(this).hasClass('faq-open')) { } else {
       // //ga('send', 'event', 'Shopping Cart Page', 'Shopping Cart Page - Information TAB - '+$(this).text(), 'Click');
    }
});
$('body.cart').find('.faq-answer a').click(function(){
	//ga('send', 'event', 'Shopping Cart Page', 'Shopping Cart Page - '+$(this).parent().parent().find('.faq-question').text()+' - Learn More', 'Click');
});
$('body.cart').find('.cl-select').click(function(){
	var select_title = '';
    if ($(this).hasClass('cl-metal-select')) {
    	select_title = 'Metal';
    } else if ($(this).hasClass('cl-size-select')) {
      	select_title = 'Size 1';
    } else if ($(this).hasClass('cl-size2-select')) {
      	select_title = 'Size 2';
    } else if ($(this).hasClass('cl-qty-select')) {
      	select_title = 'Qty';
    }
  	//ga('send', 'event', 'Shopping Cart Page', 'Shopping Cart Page - Select Dropdown - '+select_title, 'Click');
});
$('body.cart').find('.cl-item-wishlist').click(function(){
	//ga('send', 'event', 'Shopping Cart Page', 'Shopping Cart Page - Add to Wishlist', 'Click');
window.RF_Events('Shopping Cart Page', 'Shopping Cart Page - Add to Wishlist', 'Click');
});
$('body.cart').find('.cl-item-remove').click(function(){
	//ga('send', 'event', 'Shopping Cart Page', 'Shopping Cart Page - Remove from Cart', 'Click');
window.RF_Events('Shopping Cart Page', 'Shopping Cart Page - Remove from Cart', 'Click');
});
$('body.cart').find('.ct-item').find('zip').click(function(){
  	//ga('send', 'event', 'Shopping Cart Page', 'Shopping Cart Page - Add zip code', 'Click');
window.RF_Events('Shopping Cart Page', 'Shopping Cart Page - Add zip code', 'Click');
});

$('body.cart').find('.ct-item').find('.cl-product-custom-size-remove').click(function(){
  	//ga('send', 'event', 'Shopping Cart Page', 'Shopping Cart Page - Remove Custom Size', 'Click');
window.RF_Events('Shopping Cart Page', 'Shopping Cart Page - Remove Custom Size', 'Click');
});
$('body.cart').find('.ct-item').find('.cl-product-initials-remove').click(function(){
  	//ga('send', 'event', 'Shopping Cart Page', 'Shopping Cart Page - Remove Initials', 'Click');
window.RF_Events('Shopping Cart Page', 'Shopping Cart Page - Remove Initials', 'Click');
});
$('body.cart').find('.ct-item').find('.cl-product-engraving-remove').click(function(){
  	//ga('send', 'event', 'Shopping Cart Page', 'Shopping Cart Page - Remove Engraving', 'Click');
window.RF_Events('Shopping Cart Page', 'Shopping Cart Page - Remove Engraving', 'Click');
});

$('body.cart').find('.ct-item').find('.ensure.ensure-engraving').click(function(){
  	//ga('send', 'event', 'Shopping Cart Page', 'Shopping Cart Page - Add Engraving', 'Click');
window.RF_Events('Shopping Cart Page', 'Shopping Cart Page - Add Engraving', 'Click');
});
$('body.cart').find('.ct-item').find('.ring-initials-band').find('.ensure').click(function(){
  	//ga('send', 'event', 'Shopping Cart Page', 'Shopping Cart Page - Add Initials for Band', 'Click');
window.RF_Events('Shopping Cart Page', 'Shopping Cart Page - Add Initials for Band', 'Click');
});
$('body.cart').find('.ct-item').find('.ring-initials').find('.ensure').click(function(){
  	//ga('send', 'event', 'Shopping Cart Page', 'Shopping Cart Page - Add Initials', 'Click');
window.RF_Events('Shopping Cart Page', 'Shopping Cart Page - Add Initials', 'Click');
});
$('body.cart').find('.ct-item').find('.custom-size').find('.ensure').click(function(){
  	//ga('send', 'event', 'Shopping Cart Page', 'Shopping Cart Page - Add Custom Size', 'Click');
window.RF_Events('Shopping Cart Page', 'Shopping Cart Page - Add Custom Size', 'Click');
});


// Cart Page


// Wishlist
$('body.product').find('.desktop-wishlist-icon').click(function(){
    var product_title = $('#product-description h1').text();
	//ga('send', 'event', 'Wishlist', 'Product Page - Desktop - Add to Wishlist - '+product_title, 'Click');
});
$('body.product').find('.mob-wishlist-icon').click(function(){
    var product_title = $('#product-description h1').text();
	//ga('send', 'event', 'Wishlist', 'Product Page - Mobile - Add to Wishlist - '+product_title, 'Click');
});
$('body.cart').find('.cl-item-wishlist').click(function(){
    var product_title = $(this).parent().parent().find('.cl-product-title').text();
	//ga('send', 'event', 'Wishlist', 'Shopping Cart Page - Add to Wishlist - '+product_title, 'Click');
});
$("body").on("click", ".mobile-wishlist-link", function(){
	//ga('send', 'event', 'Wishlist', 'Mobile - Menu - Wishlist page - Click', 'Click');
window.RF_Events('Wishlist', 'Mobile - Menu - Wishlist page - Click', 'Click');
});
// Wishlist


// New analytics

if ($(window).width() < 960) {
$('body').find('.baa-item-desc-btn-chicago_top').click(function(){
	//ga('send', 'event', 'Rockford Private Showing', 'Rockford Private Showing - Mobile - Chicago - Book an Appontment - Top - click', 'Click');
window.RF_Events('Rockford Private Showing', 'Rockford Private Showing - Mobile - Chicago - Book an Appontment - Top - click', 'Click');
});
$('body').find('.baa-item-desc-btn-chicago_bottom').click(function(){
	//ga('send', 'event', 'Rockford Private Showing', 'Rockford Private Showing - Mobile - Chicago - Book an Appontment - Bottom - click', 'Click');
window.RF_Events('Rockford Private Showing', 'Rockford Private Showing - Mobile - Chicago - Book an Appontment - Bottom - click', 'Click');
});


$('body').find('#content-index-page .flexslider button').click(function(){
	//ga('send', 'event', 'Front Page', 'Front Page - Mobile - Head button click', 'Click');
window.RF_Events('Front Page', 'Front Page - Mobile - Head button click', 'Click');
});
$('body').find('.index-rings-content a.scroll-control.scroll-right.slick-arrow').click(function(){
	//ga('send', 'event', 'Front Page', 'Front Page - Mobile - The Legends - Arrow Right - click', 'Click');
window.RF_Events('Front Page', 'Front Page - Mobile - The Legends - Arrow Right - click', 'Click');
});
$('body').find('.index-rings-content a.scroll-control.scroll-left.slick-arrow').click(function(){
	//ga('send', 'event', 'Front Page', 'Front Page - Mobile - The Legends - Arrow Left - click', 'Click');
window.RF_Events('Front Page', 'Front Page - Mobile - The Legends - Arrow Left - click', 'Click');
});
$('body').find('.index-rings-content .rdesign-img').click(function(){
	var this_title = $(this).parents('.rdesign').find('h4').text();
	var this_variations = $(this).parents('.rdesign').find('.rdesign-variations').find('a').text();
	//ga('send', 'event', 'Front Page', 'Front Page - Mobile - The Legends - '+this_title+' '+this_variations+' - Item Image - click', 'Click');
});
$('body').find('.index-rings-content h4').click(function(){
	var this_title = $(this).parents('.rdesign').find('h4').text();
	var this_variations = $(this).parents('.rdesign').find('.rdesign-variations').find('a').text();
	//ga('send', 'event', 'Front Page', 'Front Page - Mobile - The Legends - '+this_title+' '+this_variations+' - Item Title - click', 'Click');
});
$('body').find('.index-rings-content .rdesign-variations').click(function(){
	var this_title = $(this).parents('.rdesign').find('h4').text();
	var this_variations = $(this).parents('.rdesign').find('.rdesign-variations').find('a').text();
	//ga('send', 'event', 'Front Page', 'Front Page - Mobile - The Legends - '+this_title+' '+this_variations+' - Item Variations - click', 'Click');
});
$('body').find('.index-rings-content .rdesign-variations').find('.irc-dot-item').click(function(){
	var this_title = $(this).parents('.rdesign').find('h4').text();
	var this_variations = $(this).parents('.rdesign').find('.rdesign-variations').find('a').text();
	//ga('send', 'event', 'Front Page', 'Front Page - Mobile - The Legends - '+this_title+' '+this_variations+' - Item Variations - click', 'Click');
});
$('body').find('#shopify-section-index-rings-section a.lp-eb-slider-btn.lp-eb-slider-btn-black.irc-btn').click(function(){
	//ga('send', 'event', 'Front Page', 'Front Page - Mobile - The Legends - View Styles Button - click', 'Click');
window.RF_Events('Front Page', 'Front Page - Mobile - The Legends - View Styles Button - click', 'Click');
});
$('body').find('.index-spotted-content_new .isc-item_new').click(function(){
	var this_title = $(this).data('s_title');
	//ga('send', 'event', 'Front Page', 'Front Page - Mobile - Spotted - Video - '+this_title+' - click', 'Click');
});
$('body').find('.index-spotted-content_new a.isc-content-link.lp-eb-slider-btn.lp-eb-slider-btn-black.irc-btn').click(function(){
	var this_title = $(this).parents('.isc-item_new').data('s_title');
	//ga('send', 'event', 'Front Page', 'Front Page - Mobile - Spotted - Video - '+this_title+' - View Style Btn - click', 'Click');
});
$('body').find('.index-spotted-content_new .isc-right-arrow').click(function(){
	//ga('send', 'event', 'Front Page', 'Front Page - Mobile - Spotted - Right Arrow - click', 'Click');
window.RF_Events('Front Page', 'Front Page - Mobile - Spotted - Right Arrow - click', 'Click');
});
$('body').find('.index-spotted-content_new .isc-left-arrow').click(function(){
	//ga('send', 'event', 'Front Page', 'Front Page - Mobile - Spotted - Left Arrow - click', 'Click');
window.RF_Events('Front Page', 'Front Page - Mobile - Spotted - Left Arrow - click', 'Click');
});
$('body').find('a.lp-eb-slider-btn.lp-eb-slider-btn-black').click(function(){
	//ga('send', 'event', 'Front Page', 'Front Page - Mobile - Parallax - View Ring Btn - click', 'Click');
window.RF_Events('Front Page', 'Front Page - Mobile - Parallax - View Ring Btn - click', 'Click');
});
$('body').find('#shopify-section-index-accordion-section .hp-rt-item-block-url a').click(function(){
	var this_title = $(this).parents('.hp-rt-item').find('.hp-rt-item-block-title').text();
	//ga('send', 'event', 'Front Page', 'Front Page - Mobile - Accordion Block - '+this_title+' - Discover Collection - click', 'Click');
});
$('body').find('#shopify-section-index-accordion-section .hp-rt-item-product-content a').click(function(){
	var this_title = $(this).parents('.hp-rt-item').find('.hp-rt-item-block-title').text();
	var this_product = $(this).find('.hp-rt-item-pc-title').text();
	//ga('send', 'event', 'Front Page', 'Front Page - Mobile - Accordion Block - '+this_title+' - Product - '+this_product+' - click', 'Click');
});
$('body').find('#shopify-section-index-accordion-section a.scroll-control.scroll-right.slick-arrow').click(function(){
	var this_title = $(this).parents('.hp-rt-item').find('.hp-rt-item-block-title').text();
	//ga('send', 'event', 'Front Page', 'Front Page - Mobile - Accordion Block - '+this_title+' - Arrow Right - click', 'Click');
});
$('body').find('#shopify-section-index-accordion-section a.scroll-control.scroll-left.slick-arrow').click(function(){
	var this_title = $(this).parents('.hp-rt-item').find('.hp-rt-item-block-title').text();
	//ga('send', 'event', 'Front Page', 'Front Page - Mobile - Accordion Block - '+this_title+' - Arrow Left - click', 'Click');
});
$('body').find('body.index .index-book-an-appointment-block .baa-desc').find('a').click(function(){
	var this_title = $(this).text();
	//ga('send', 'event', 'Front Page', 'Front Page - Mobile - Middle Book an Appointment - '+this_title+' link - click', 'Click');
});
$('body').find('body.index .index-book-an-appointment-block .baa-items > .baa-item:nth-child(1) .baa-item-desc-btn').click(function(){
	//ga('send', 'event', 'Front Page', 'Front Page - Mobile - Middle Book an Appointment - Virtual Consultation - click', 'Click');
window.RF_Events('Front Page', 'Front Page - Mobile - Middle Book an Appointment - Virtual Consultation - click', 'Click');
});
$('body').find('body.index .index-book-an-appointment-block .baa-items > .baa-item:nth-child(2) .baa-item-desc-btn').click(function(){
	//ga('send', 'event', 'Front Page', 'Front Page - Mobile - Middle Book an Appointment - Miami Consultation - click', 'Click');
window.RF_Events('Front Page', 'Front Page - Mobile - Middle Book an Appointment - Miami Consultation - click', 'Click');
});
$('body').find('body.index .index-book-an-appointment-block .baa-items > .baa-item:nth-child(3) .baa-item-desc-btn').click(function(){
	//ga('send', 'event', 'Front Page', 'Front Page - Mobile - Middle Book an Appointment - NY Consultation - click', 'Click');
window.RF_Events('Front Page', 'Front Page - Mobile - Middle Book an Appointment - NY Consultation - click', 'Click');
});
$('body').find('body.index .index-book-an-appointment-block .baa-items > .baa-item:nth-child(1) img').click(function(){
	//ga('send', 'event', 'Front Page', 'Front Page - Mobile - Middle Book an Appointment - Virtual Consultation - Banner - click', 'Click');
window.RF_Events('Front Page', 'Front Page - Mobile - Middle Book an Appointment - Virtual Consultation - Banner - click', 'Click');
});
$('body').find('body.index .index-book-an-appointment-block .baa-items > .baa-item:nth-child(2) img').click(function(){
	//ga('send', 'event', 'Front Page', 'Front Page - Mobile - Middle Book an Appointment - Miami Consultation - Banner - click', 'Click');
window.RF_Events('Front Page', 'Front Page - Mobile - Middle Book an Appointment - Miami Consultation - Banner - click', 'Click');
});
$('body').find('body.index .index-book-an-appointment-block .baa-items > .baa-item:nth-child(3) img').click(function(){
	//ga('send', 'event', 'Front Page', 'Front Page - Mobile - Middle Book an Appointment - NY Consultation - Banner - click', 'Click');
window.RF_Events('Front Page', 'Front Page - Mobile - Middle Book an Appointment - NY Consultation - Banner - click', 'Click');
});

$('body').find('.index-book-an-appointment-footer .index-book-an-appointment-block .baa-desc').find('a').click(function(){
	var this_title = $(this).text();
	//ga('send', 'event', 'Front Page', 'Book an Appointment - Mobile - Book an Appointment - '+this_title+' link - click', 'Click');
});
$('body').find('.index-book-an-appointment-footer .baa-items > .baa-item:nth-child(1) .baa-item-desc-btn').click(function(){
	//ga('send', 'event', 'Book an Appointment Block', 'Book an Appointment - Mobile - Book an Appointment - Virtual Consultation - click', 'Click');
window.RF_Events('Book an Appointment Block', 'Book an Appointment - Mobile - Book an Appointment - Virtual Consultation - click', 'Click');
});
$('body').find('.index-book-an-appointment-footer .baa-items > .baa-item:nth-child(2) .baa-item-desc-btn').click(function(){
	//ga('send', 'event', 'Book an Appointment Block', 'Book an Appointment - Mobile - Book an Appointment - Miami Consultation - click', 'Click');
window.RF_Events('Book an Appointment Block', 'Book an Appointment - Mobile - Book an Appointment - Miami Consultation - click', 'Click');
});
$('body').find('.index-book-an-appointment-footer .baa-items > .baa-item:nth-child(3) .baa-item-desc-btn').click(function(){
	//ga('send', 'event', 'Book an Appointment Block', 'Book an Appointment - Mobile - Book an Appointment - NY Consultation - click', 'Click');
window.RF_Events('Book an Appointment Block', 'Book an Appointment - Mobile - Book an Appointment - NY Consultation - click', 'Click');
});
$('body').find('.index-book-an-appointment-footer .baa-items > .baa-item:nth-child(1) img').click(function(){
	//ga('send', 'event', 'Book an Appointment Block', 'Book an Appointment - Mobile - Book an Appointment - Virtual Consultation - Banner - click', 'Click');
window.RF_Events('Book an Appointment Block', 'Book an Appointment - Mobile - Book an Appointment - Virtual Consultation - Banner - click', 'Click');
});
$('body').find('.index-book-an-appointment-footer .baa-items > .baa-item:nth-child(2) img').click(function(){
	//ga('send', 'event', 'Book an Appointment Block', 'Book an Appointment - Mobile - Book an Appointment - Miami Consultation - Banner - click', 'Click');
window.RF_Events('Book an Appointment Block', 'Book an Appointment - Mobile - Book an Appointment - Miami Consultation - Banner - click', 'Click');
});
$('body').find('.index-book-an-appointment-footer .baa-items > .baa-item:nth-child(3) img').click(function(){
	//ga('send', 'event', 'Book an Appointment Block', 'Book an Appointment - Mobile - Book an Appointment - NY Consultation - Banner - click', 'Click');
window.RF_Events('Book an Appointment Block', 'Book an Appointment - Mobile - Book an Appointment - NY Consultation - Banner - click', 'Click');
});

$('body').find('.bap-paginations a').click(function(){
	//ga('send', 'event', 'Collection Page', 'Collection Page - Mobile - View All - click', 'Click');
window.RF_Events('Collection Page', 'Collection Page - Mobile - View All - click', 'Click');
});
$('body').find('.mpal-item-grid-selector.mpal-item-grid-selector-standart').click(function(){
	//ga('send', 'event', 'Collection Page', 'Collection Page - Mobile - Grid View - click', 'Click');
window.RF_Events('Collection Page', 'Collection Page - Mobile - Grid View - click', 'Click');
});
$('body').find('.mpal-item-grid-selector.mpal-item-grid-selector-full').click(function(){
	//ga('send', 'event', 'Collection Page', 'Collection Page - Mobile - List View - click', 'Click');
window.RF_Events('Collection Page', 'Collection Page - Mobile - List View - click', 'Click');
});

$('body').find('.rpc-item-inner-column-item.rpc-item-inner-column-item-book-appontment').click(function(){
	//ga('send', 'event', 'Product Page', 'Product Page - Mobile - Book Appontment - click', 'Click');
window.RF_Events('Product Page', 'Product Page - Mobile - Book Appontment - click', 'Click');
});
$('body').find('.rpc-item-inner-column-item.rpc-item-inner-column-item-order-sample').click(function(){
	//ga('send', 'event', 'Product Page', 'Product Page - Mobile - Order Sample - click', 'Click');
window.RF_Events('Product Page', 'Product Page - Mobile - Order Sample - click', 'Click');
});
$('body').find('.rpc-item-inner-column-item.rpc-item-inner-column-item-order-ring-sizer').click(function(){
	//ga('send', 'event', 'Product Page', 'Product Page - Mobile - Ring Sizer - click', 'Click');
window.RF_Events('Product Page', 'Product Page - Mobile - Ring Sizer - click', 'Click');
});
$('body').find('.rpc-item-inner-column-item.rpc-item-inner-column-item-call').click(function(){
	//ga('send', 'event', 'Product Page', 'Product Page - Mobile - Call Icon - click', 'Click');
window.RF_Events('Product Page', 'Product Page - Mobile - Call Icon - click', 'Click');
});
$('body').find('.rpc-item-inner-column-item.rpc-item-inner-column-item-email-us').click(function(){
	//ga('send', 'event', 'Product Page', 'Product Page - Mobile - Email Icon - click', 'Click');
window.RF_Events('Product Page', 'Product Page - Mobile - Email Icon - click', 'Click');
});
$('body').find('.want-to_customize_this_ring').click(function(){
	//ga('send', 'event', 'Product Page', 'Product Page - Mobile - Want to Customize this ring? - click', 'Click');
window.RF_Events('Product Page', 'Product Page - Mobile - Want to Customize this ring? - click', 'Click');
});
$('body').find('.pp-item.fancybox').click(function(){
	//ga('send', 'event', 'Product Page', 'Product Page - Mobile - Gallery Open - click', 'Click');
window.RF_Events('Product Page', 'Product Page - Mobile - Gallery Open - click', 'Click');
});
$('body').find('.pdp-selector-value.pdp-selector-value-metal').click(function(){
	//ga('send', 'event', 'Product Page', 'Product Page - Mobile - Metal Selector Open - click', 'Click');
window.RF_Events('Product Page', 'Product Page - Mobile - Metal Selector Open - click', 'Click');
});
$('body').find('.pdp-selector-value.pdp-selector-value-size').click(function(){
	//ga('send', 'event', 'Product Page', 'Product Page - Mobile - Size Selector Open - click', 'Click');
window.RF_Events('Product Page', 'Product Page - Mobile - Size Selector Open - click', 'Click');
});
$('body').find('.pdp-selector.pdp-selector-initials-and-engraving').click(function(){
	//ga('send', 'event', 'Product Page', 'Product Page - Mobile - Engraving and Initials Selector Open - click', 'Click');
window.RF_Events('Product Page', 'Product Page - Mobile - Engraving and Initials Selector Open - click', 'Click');
});
$('body').find('.product_addititonal_variations a').click(function(){
	//ga('send', 'event', 'Product Page', 'Product Page - Mobile - Additional Variations Click - click', 'Click');
window.RF_Events('Product Page', 'Product Page - Mobile - Additional Variations Click - click', 'Click');
});
$('body').find('.mob-breadcrumbs a').click(function(){
	//ga('send', 'event', 'Product Page', 'Product Page - Mobile - Breadcrumbs - click', 'Click');
window.RF_Events('Product Page', 'Product Page - Mobile - Breadcrumbs - click', 'Click');
});
$('body').find('.converted-faq').find('.faq-question').click(function(){
	var this_title = $(this).text();
	//ga('send', 'event', 'Customer Service Page', 'Customer Service Page - Mobile - '+this_title+' - click', 'Click');
});
$('body').find('.converted-faq').find('.faq-item').find('a').click(function(){
	var this_title = $(this).parents('.faq-item').find('faq-question').text();
	//ga('send', 'event', 'Customer Service Page', 'Customer Service Page - Mobile - '+this_title+' - Button - click', 'Click');
});
$('body.collection').find('.product-index').find('a').click(function(){
	var this_title = $(this).parents('.product-index').find('.product-info').find('a').text();
	var this_diamonds = $(this).parents('.product-index').find('.product-info').find('.pi-diamonds').text();
	var collection_title = $('body').find('.catdesc-right').find('h1').text();
	//ga('send', 'event', collection_title+' Collection Page', collection_title+' Collection Page - Mobile - '+this_title+' '+this_diamonds+' - click', 'Click');
});
$('body.collection').find('.product-index').find('.col-swatch').find('.color').mouseenter(function(){
	var this_title = $(this).parents('.product-index').find('.product-info').find('a').text();
	var this_diamonds = $(this).parents('.product-index').find('.product-info').find('.pi-diamonds').text();
	var this_color = $(this).data('option-title');
	var collection_title = $('body').find('.catdesc-right').find('h1').text();
	//ga('send', 'event', collection_title+' Collection Page', collection_title+' Collection Page - Mobile - '+this_title+' '+this_diamonds+' - '+this_color+' - Hover', 'Click');
});
$('body.product').find('.rpc-item-inner-columns').find('.rpc-item-inner-column-item').click(function(){
	var this_title = $(this).find('.rpc-item-inner-column-item-title').text();
	var product_title = $('body').find('.product-description').find('h1').text();
	//ga('send', 'event', 'Product Page', 'Product Page - Mobile - '+product_title+' - '+this_title+' - click', 'Click');
});
$('body.product').find('.rpc-item.rpc-item-dropdown').click(function(){
	var this_title = $(this).find('.rpc-item-title').text();
	var product_title = $('body').find('.product-description').find('h1').text();
	//ga('send', 'event', 'Product Page', 'Product Page - Mobile - '+product_title+' - '+this_title+' - click', 'Click');
});

} else {
$('body').find('.baa-item-desc-btn-chicago_top').click(function(){
	//ga('send', 'event', 'Rockford Private Showing', 'Rockford Private Showing - Desktop - Chicago - Book an Appontment - Top - click', 'Click');
window.RF_Events('Rockford Private Showing', 'Rockford Private Showing - Desktop - Chicago - Book an Appontment - Top - click', 'Click');
});
$('body').find('.baa-item-desc-btn-chicago_bottom').click(function(){
	//ga('send', 'event', 'Rockford Private Showing', 'Rockford Private Showing - Desktop - Chicago - Book an Appontment - Bottom - click', 'Click');
window.RF_Events('Rockford Private Showing', 'Rockford Private Showing - Desktop - Chicago - Book an Appontment - Bottom - click', 'Click');
});


$('body').find('#content-index-page .flexslider button').click(function(){
	//ga('send', 'event', 'Front Page', 'Front Page - Desktop - Head button click', 'Click');
window.RF_Events('Front Page', 'Front Page - Desktop - Head button click', 'Click');
});
$('body').find('.index-rings-content a.scroll-control.scroll-right.slick-arrow').click(function(){
	//ga('send', 'event', 'Front Page', 'Front Page - Desktop - The Legends - Arrow Right - click', 'Click');
window.RF_Events('Front Page', 'Front Page - Desktop - The Legends - Arrow Right - click', 'Click');
});
$('body').find('.index-rings-content a.scroll-control.scroll-left.slick-arrow').click(function(){
	//ga('send', 'event', 'Front Page', 'Front Page - Desktop - The Legends - Arrow Left - click', 'Click');
window.RF_Events('Front Page', 'Front Page - Desktop - The Legends - Arrow Left - click', 'Click');
});
$('body').find('.index-rings-content .rdesign-img').click(function(){
	var this_title = $(this).parents('.rdesign').find('h4').text();
	var this_variations = $(this).parents('.rdesign').find('.rdesign-variations').find('a').text();
	//ga('send', 'event', 'Front Page', 'Front Page - Desktop - The Legends - '+this_title+' '+this_variations+' - Item Image - click', 'Click');
});
$('body').find('.index-rings-content h4').click(function(){
	var this_title = $(this).parents('.rdesign').find('h4').text();
	var this_variations = $(this).parents('.rdesign').find('.rdesign-variations').find('a').text();
	//ga('send', 'event', 'Front Page', 'Front Page - Desktop - The Legends - '+this_title+' '+this_variations+' - Item Title - click', 'Click');
});
$('body').find('.index-rings-content .rdesign-variations').click(function(){
	var this_title = $(this).parents('.rdesign').find('h4').text();
	var this_variations = $(this).parents('.rdesign').find('.rdesign-variations').find('a').text();
	//ga('send', 'event', 'Front Page', 'Front Page - Desktop - The Legends - '+this_title+' '+this_variations+' - Item Variations - click', 'Click');
});
$('body').find('.index-rings-content .rdesign-variations').find('.irc-dot-item').click(function(){
	var this_title = $(this).parents('.rdesign').find('h4').text();
	var this_variations = $(this).parents('.rdesign').find('.rdesign-variations').find('a').text();
	//ga('send', 'event', 'Front Page', 'Front Page - Desktop - The Legends - '+this_title+' '+this_variations+' - Item Variations - click', 'Click');
});
$('body').find('#shopify-section-index-rings-section a.lp-eb-slider-btn.lp-eb-slider-btn-black.irc-btn').click(function(){
	//ga('send', 'event', 'Front Page', 'Front Page - Desktop - The Legends - View Styles Button - click', 'Click');
window.RF_Events('Front Page', 'Front Page - Desktop - The Legends - View Styles Button - click', 'Click');
});
$('body').find('.index-spotted-content_new .isc-item_new').click(function(){
	var this_title = $(this).data('s_title');
	//ga('send', 'event', 'Front Page', 'Front Page - Desktop - Spotted - Video - '+this_title+' - click', 'Click');
});
$('body').find('.index-spotted-content_new a.isc-content-link.lp-eb-slider-btn.lp-eb-slider-btn-black.irc-btn').click(function(){
	var this_title = $(this).parents('.isc-item_new').data('s_title');
	//ga('send', 'event', 'Front Page', 'Front Page - Desktop - Spotted - Video - '+this_title+' - View Style Btn - click', 'Click');
});
$('body').find('.index-spotted-content_new .isc-right-arrow').click(function(){
	//ga('send', 'event', 'Front Page', 'Front Page - Desktop - Spotted - Right Arrow - click', 'Click');
window.RF_Events('Front Page', 'Front Page - Desktop - Spotted - Right Arrow - click', 'Click');
});
$('body').find('.index-spotted-content_new .isc-left-arrow').click(function(){
	//ga('send', 'event', 'Front Page', 'Front Page - Desktop - Spotted - Left Arrow - click', 'Click');
window.RF_Events('Front Page', 'Front Page - Desktop - Spotted - Left Arrow - click', 'Click');
});
$('body').find('a.lp-eb-slider-btn.lp-eb-slider-btn-black').click(function(){
	//ga('send', 'event', 'Front Page', 'Front Page - Desktop - Parallax - View Ring Btn - click', 'Click');
window.RF_Events('Front Page', 'Front Page - Desktop - Parallax - View Ring Btn - click', 'Click');
});
$('body').find('#shopify-section-index-accordion-section .hp-rt-item-block-url a').click(function(){
	var this_title = $(this).parents('.hp-rt-item').find('.hp-rt-item-block-title').text();
	//ga('send', 'event', 'Front Page', 'Front Page - Desktop - Accordion Block - '+this_title+' - Discover Collection - click', 'Click');
});
$('body').find('#shopify-section-index-accordion-section .hp-rt-item-product-content a').click(function(){
	var this_title = $(this).parents('.hp-rt-item').find('.hp-rt-item-block-title').text();
	var this_product = $(this).find('.hp-rt-item-pc-title').text();
	//ga('send', 'event', 'Front Page', 'Front Page - Desktop - Accordion Block - '+this_title+' - Product - '+this_product+' - click', 'Click');
});
$('body').find('#shopify-section-index-accordion-section a.scroll-control.scroll-right.slick-arrow').click(function(){
	var this_title = $(this).parents('.hp-rt-item').find('.hp-rt-item-block-title').text();
	//ga('send', 'event', 'Front Page', 'Front Page - Desktop - Accordion Block - '+this_title+' - Arrow Right - click', 'Click');
});
$('body').find('#shopify-section-index-accordion-section a.scroll-control.scroll-left.slick-arrow').click(function(){
	var this_title = $(this).parents('.hp-rt-item').find('.hp-rt-item-block-title').text();
	//ga('send', 'event', 'Front Page', 'Front Page - Desktop - Accordion Block - '+this_title+' - Arrow Left - click', 'Click');
});
$('body').find('body.index .index-book-an-appointment-block .baa-desc').find('a').click(function(){
	var this_title = $(this).text();
	//ga('send', 'event', 'Front Page', 'Front Page - Desktop - Middle Book an Appointment - '+this_title+' link - click', 'Click');
});
$('body').find('body.index .index-book-an-appointment-block .baa-items > .baa-item:nth-child(1) .baa-item-desc-btn').click(function(){
	//ga('send', 'event', 'Front Page', 'Front Page - Desktop - Middle Book an Appointment - Virtual Consultation - click', 'Click');
window.RF_Events('Front Page', 'Front Page - Desktop - Middle Book an Appointment - Virtual Consultation - click', 'Click');
});
$('body').find('body.index .index-book-an-appointment-block .baa-items > .baa-item:nth-child(2) .baa-item-desc-btn').click(function(){
	//ga('send', 'event', 'Front Page', 'Front Page - Desktop - Middle Book an Appointment - Miami Consultation - click', 'Click');
window.RF_Events('Front Page', 'Front Page - Desktop - Middle Book an Appointment - Miami Consultation - click', 'Click');
});
$('body').find('body.index .index-book-an-appointment-block .baa-items > .baa-item:nth-child(3) .baa-item-desc-btn').click(function(){
	//ga('send', 'event', 'Front Page', 'Front Page - Desktop - Middle Book an Appointment - NY Consultation - click', 'Click');
window.RF_Events('Front Page', 'Front Page - Desktop - Middle Book an Appointment - NY Consultation - click', 'Click');
});
$('body').find('body.index .index-book-an-appointment-block .baa-items > .baa-item:nth-child(1) img').click(function(){
	//ga('send', 'event', 'Front Page', 'Front Page - Desktop - Middle Book an Appointment - Virtual Consultation - Banner - click', 'Click');
window.RF_Events('Front Page', 'Front Page - Desktop - Middle Book an Appointment - Virtual Consultation - Banner - click', 'Click');
});
$('body').find('body.index .index-book-an-appointment-block .baa-items > .baa-item:nth-child(2) img').click(function(){
	//ga('send', 'event', 'Front Page', 'Front Page - Desktop - Middle Book an Appointment - Miami Consultation - Banner - click', 'Click');
window.RF_Events('Front Page', 'Front Page - Desktop - Middle Book an Appointment - Miami Consultation - Banner - click', 'Click');
});
$('body').find('body.index .index-book-an-appointment-block .baa-items > .baa-item:nth-child(3) img').click(function(){
	//ga('send', 'event', 'Front Page', 'Front Page - Desktop - Middle Book an Appointment - NY Consultation - Banner - click', 'Click');
window.RF_Events('Front Page', 'Front Page - Desktop - Middle Book an Appointment - NY Consultation - Banner - click', 'Click');
});

$('body').find('.index-book-an-appointment-footer .baa-items > .baa-item:nth-child(1) .baa-item-desc-btn').click(function(){
	//ga('send', 'event', 'Book an Appointment Block', 'Book an Appointment - Desktop - Book an Appointment - Virtual Consultation - click', 'Click');
window.RF_Events('Book an Appointment Block', 'Book an Appointment - Desktop - Book an Appointment - Virtual Consultation - click', 'Click');
});
$('body').find('.index-book-an-appointment-footer .baa-items > .baa-item:nth-child(2) .baa-item-desc-btn').click(function(){
	//ga('send', 'event', 'Book an Appointment Block', 'Book an Appointment - Desktop - Book an Appointment - Miami Consultation - click', 'Click');
window.RF_Events('Book an Appointment Block', 'Book an Appointment - Desktop - Book an Appointment - Miami Consultation - click', 'Click');
});
$('body').find('.index-book-an-appointment-footer .baa-items > .baa-item:nth-child(3) .baa-item-desc-btn').click(function(){
	//ga('send', 'event', 'Book an Appointment Block', 'Book an Appointment - Desktop - Book an Appointment - NY Consultation - click', 'Click');
window.RF_Events('Book an Appointment Block', 'Book an Appointment - Desktop - Book an Appointment - NY Consultation - click', 'Click');
});
$('body').find('.index-book-an-appointment-footer .baa-items > .baa-item:nth-child(1) img').click(function(){
	//ga('send', 'event', 'Book an Appointment Block', 'Book an Appointment - Desktop - Book an Appointment - Virtual Consultation - Banner - click', 'Click');
window.RF_Events('Book an Appointment Block', 'Book an Appointment - Desktop - Book an Appointment - Virtual Consultation - Banner - click', 'Click');
});
$('body').find('.index-book-an-appointment-footer .baa-items > .baa-item:nth-child(2) img').click(function(){
	//ga('send', 'event', 'Book an Appointment Block', 'Book an Appointment - Desktop - Book an Appointment - Miami Consultation - Banner - click', 'Click');
window.RF_Events('Book an Appointment Block', 'Book an Appointment - Desktop - Book an Appointment - Miami Consultation - Banner - click', 'Click');
});
$('body').find('.index-book-an-appointment-footer .baa-items > .baa-item:nth-child(3) img').click(function(){
	//ga('send', 'event', 'Book an Appointment Block', 'Book an Appointment - Desktop - Book an Appointment - NY Consultation - Banner - click', 'Click');
window.RF_Events('Book an Appointment Block', 'Book an Appointment - Desktop - Book an Appointment - NY Consultation - Banner - click', 'Click');
});

$('body').find('.bap-paginations a').click(function(){
	//ga('send', 'event', 'Collection Page', 'Collection Page - Desktop - View All - click', 'Click');
window.RF_Events('Collection Page', 'Collection Page - Desktop - View All - click', 'Click');
});

$('body').find('.rpc-item-inner-column-item.rpc-item-inner-column-item-book-appontment').click(function(){
	//ga('send', 'event', 'Product Page', 'Product Page - Desktop - Book Appontment - click', 'Click');
window.RF_Events('Product Page', 'Product Page - Desktop - Book Appontment - click', 'Click');
});
$('body').find('.rpc-item-inner-column-item.rpc-item-inner-column-item-order-sample').click(function(){
	//ga('send', 'event', 'Product Page', 'Product Page - Desktop - Order Sample - click', 'Click');
window.RF_Events('Product Page', 'Product Page - Desktop - Order Sample - click', 'Click');
});
$('body').find('.rpc-item-inner-column-item.rpc-item-inner-column-item-order-ring-sizer').click(function(){
	//ga('send', 'event', 'Product Page', 'Product Page - Desktop - Ring Sizer - click', 'Click');
window.RF_Events('Product Page', 'Product Page - Desktop - Ring Sizer - click', 'Click');
});
$('body').find('.rpc-item-inner-column-item.rpc-item-inner-column-item-call').click(function(){
	//ga('send', 'event', 'Product Page', 'Product Page - Desktop - Call Icon - click', 'Click');
window.RF_Events('Product Page', 'Product Page - Desktop - Call Icon - click', 'Click');
});
$('body').find('.rpc-item-inner-column-item.rpc-item-inner-column-item-email-us').click(function(){
	//ga('send', 'event', 'Product Page', 'Product Page - Desktop - Email Icon - click', 'Click');
window.RF_Events('Product Page', 'Product Page - Desktop - Email Icon - click', 'Click');
});
$('body').find('.want-to_customize_this_ring').click(function(){
	//ga('send', 'event', 'Product Page', 'Product Page - Desktop - Want to Customize this ring? - click', 'Click');
window.RF_Events('Product Page', 'Product Page - Desktop - Want to Customize this ring? - click', 'Click');
});
$('body').find('.pp-item.fancybox').click(function(){
	//ga('send', 'event', 'Product Page', 'Product Page - Desktop - Gallery Open - click', 'Click');
window.RF_Events('Product Page', 'Product Page - Desktop - Gallery Open - click', 'Click');
});
$('body').find('.pdp-selector-value.pdp-selector-value-metal').click(function(){
	//ga('send', 'event', 'Product Page', 'Product Page - Desktop - Metal Selector Open - click', 'Click');
window.RF_Events('Product Page', 'Product Page - Desktop - Metal Selector Open - click', 'Click');
});
$('body').find('.pdp-selector-value.pdp-selector-value-size').click(function(){
	//ga('send', 'event', 'Product Page', 'Product Page - Desktop - Size Selector Open - click', 'Click');
window.RF_Events('Product Page', 'Product Page - Desktop - Size Selector Open - click', 'Click');
});
$('body').find('.pdp-selector.pdp-selector-initials-and-engraving').click(function(){
	//ga('send', 'event', 'Product Page', 'Product Page - Desktop - Engraving and Initials Selector Open - click', 'Click');
window.RF_Events('Product Page', 'Product Page - Desktop - Engraving and Initials Selector Open - click', 'Click');
});
$('body').find('.product_addititonal_variations a').click(function(){
	//ga('send', 'event', 'Product Page', 'Product Page - Desktop - Additional Variations Click - click', 'Click');
window.RF_Events('Product Page', 'Product Page - Desktop - Additional Variations Click - click', 'Click');
});

// $('body').find('.converted-faq').find('.faq-question').click(function(){
// 	var this_title = $(this).text();
// 	//ga('send', 'event', 'Customer Service Page', 'Customer Service Page - Desktop - '+this_title+' - click', 'Click');
// });
// $('body').find('.converted-faq').find('.faq-item').find('a').click(function(){
// 	var this_title = $(this).parents('.faq-item').find('faq-question').text();
// 	//ga('send', 'event', 'Customer Service Page', 'Customer Service Page - Desktop - '+this_title+' - Button - click', 'Click');
// });
// $('body.collection').find('.product-index').find('a').click(function(){
// 	var this_title = $(this).parents('.product-index').find('.product-info').find('a').text();
// 	var this_diamonds = $(this).parents('.product-index').find('.product-info').find('.pi-diamonds').text();
// 	var collection_title = $('body').find('.catdesc-right').find('h1').text();
// 	//ga('send', 'event', collection_title+' Collection Page', collection_title+' Collection Page - Desktop - '+this_title+' '+this_diamonds+' - click', 'Click');
// });
// $('body.collection').find('.product-index').find('.col-swatch').find('.color').mouseenter(function(){
// 	var this_title = $(this).parents('.product-index').find('.product-info').find('a').text();
// 	var this_diamonds = $(this).parents('.product-index').find('.product-info').find('.pi-diamonds').text();
// 	var this_color = $(this).data('option-title');
// 	var collection_title = $('body').find('.catdesc-right').find('h1').text();
// 	//ga('send', 'event', collection_title+' Collection Page', collection_title+' Collection Page - Desktop - '+this_title+' '+this_diamonds+' - '+this_color+' - Hover', 'Click');
// });
// $('body.product').find('.rpc-item-inner-columns').find('.rpc-item-inner-column-item').click(function(){
// 	var this_title = $(this).find('.rpc-item-inner-column-item-title').text();
// 	var product_title = $('body').find('.product-description').find('h1').text();
// 	//ga('send', 'event', 'Product Page', 'Product Page - Desktop - '+product_title+' - '+this_title+' - click', 'Click');
// });
// $('body.product').find('.rpc-item.rpc-item-dropdown').click(function(){
// 	var this_title = $(this).find('.rpc-item-title').text();
// 	var product_title = $('body').find('.product-description').find('h1').text();
// 	//ga('send', 'event', 'Product Page', 'Product Page - Desktop - '+product_title+' - '+this_title+' - click', 'Click');
// });

}